module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/1-6dd9f72bb9542c26e295cb175e42cf6b.jpg";